import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getActiveSalon } from 'Containers/Auth/store/selectors';
import {
  getCustomerProducts,
  getSubscriptionStatus,
} from 'Containers/Settings/store/selectors';
import { getActivePlan } from 'Containers/Scheduler/containers/CalendarHeader/utils/getActivePlan';

const selectActiveSalon = getActiveSalon();
const selectCustomerProducts = getCustomerProducts();
const selectSubscriptionStatus = getSubscriptionStatus();

/**
 * Piano attivo (sola lettura dallo store).
 * Non dispatcha API: bootstrap unico in App (login) + setActiveSalon (cambio salone);
 * la saga getDaysLeft allinea già subscription/status.
 */
export default function useActivePlan() {
  const activeSalon = useSelector(selectActiveSalon);
  const products = useSelector(selectCustomerProducts);
  const subscriptionStatus = useSelector(selectSubscriptionStatus);

  const currentPriceId = subscriptionStatus?.currentPriceId || null;
  const hasProducts = Boolean(products && Object.keys(products).length);

  return useMemo(
    () =>
      getActivePlan({
        products: hasProducts ? products : { prezzo: activeSalon?.prezzo },
        currentPriceId,
      }),
    [hasProducts, products, activeSalon?.prezzo, currentPriceId],
  );
}
